import StatusChip from './statusChip';

export default StatusChip;
